export default __webpack_public_path__ + "static/media/home-banner.51ea576f.jpg";